import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  className = '',
  fullWidth = false
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={onClick} className={`
        bg-neon text-black font-display font-bold text-xl md:text-2xl py-4 px-8 rounded-full 
        shadow-[0_0_20px_rgba(198,255,0,0.4)] hover:shadow-[0_0_30px_rgba(198,255,0,0.6)] 
        transition-shadow uppercase tracking-wide flex items-center justify-center gap-2
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-286">
      {children}
    </motion.button>;
}